module.exports = __webpack_public_path__ + "img/ico-start.237a4876.svg";